// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".messenger__dropzone{min-height:32px;border:4px dashed rgba(0,10,30,.1);border-radius:2px}.messenger__dropzone.messenger__dropzone--dragover{border:4px dashed rgba(250,0,25,.4)}", ""]);
// Exports
module.exports = exports;
